import env from '../../env';
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getArticle = createAsyncThunk('article/getArticle', async (arg, { rejectWithValue }) => {
  const microsoftJWT = localStorage.getItem('microsoftJWT');
  const url = `${env.API_URL}/articles/${arg}?populate[rma][populate]=debitor`;
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(microsoftJWT ? { jwt: microsoftJWT } : {}),
  };

  try {
    const { data } = await axios.get(url, { headers });
    return data;
  } catch (err) {
    return rejectWithValue(err?.response?.data ?? err.message);
  }
});

export const postXLSX = createAsyncThunk(
  'article/postXLSX',
  async (arg, { getState, rejectWithValue }) => {
    const state = getState();
    const articlesXLSX = state.article.xlsxArticles;
    const customerID = state.customer?.data?.id;
    const customerCode = state.customer?.data?.customerCode;

    if (!customerID || !customerCode) {
      return rejectWithValue('No customer loaded');
    }

    try {
      const { data } = await axios.post(
        `${env.API_URL_PREFIX}/service-xlsx/${customerID}/${customerCode}/${arg}`,
        articlesXLSX,
        {
          headers: {
            jwt: localStorage.getItem('microsoftJWT'),
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  }
);
